import React from "react";

const CircleSvg = () => (
  <svg width="1em" height="1.1em">
    <circle
      cx="12"
      cy="12"
      r="6"
      stroke="#8D93A1"
      stroke-width="1"
      fill="#8D93A1"
    />
  </svg>
);

export default CircleSvg;
